<template>
  <div class="page-container">
    <el-card>
      <app-table
        ref="table"
        :table-key="table_key"
        :get-data="getRolesList"
        :is-current-page="false"
      />
    </el-card>
    <!-- 分配角色权限  -->
    <el-dialog
      title="分配角色权限"
      :visible.sync="dialog_config.is_show"
      width="500px"
    >
      <assignPermission
        v-if="dialog_config.is_show"
        :data="dialog_config.data"
        @comfirm="dialog_config.comfirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
    <!-- 分配角色游戏权限  -->
    <el-dialog v-bind="assign_games_config.props" :visible.sync="assign_games_config.is_show">
      <assignGamePermission
        v-if="assign_games_config.is_show"
        :raw-data="assign_games_config.raw_data"
        @confirm="confirmAssignGame"
        @cancel="assign_games_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import RolesResource from '@/api/roles';
const rolesResource = new RolesResource();

export default {
  components: {
    'assignPermission': () => import('@/views/system/role-manage/components/assignPermission'),
    'assignGamePermission': () => import('@/views/system/role-manage/components/assignGamePermission'),
    'app-table': () => import('@/components/app-table'),
  },
  data() {
    return {
      table_key: require('./model/table-key.js')(this),
      dialog_config: {
        is_show: false,
        data: {},
        comfirm: () => {},
      },
      assign_games_config: {
        is_show: false,
        raw_data: {},
        props: {
          title: '分配角色游戏权限「不设置游戏权限时，即拥有全游戏权限」',
          width: '800px',
        },
      },
    };
  },
  methods: {
    getRolesList() {
      return new Promise((resolve, reject) => {
        rolesResource
          .getRolesApi()
          .then(({ list }) => {
            resolve(list);
          }).catch(reject);
      });
    },
    assignPermission(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        data: row,
        comfirm: () => {
          this.$refs.table.refer();
          this.dialog_config.is_show = false;
        },
      });
    },
    /**
     * 打开分配游戏权限弹窗
     * @param {Record<string,any>} row 当前行数据
     */
    openAssignGamesDialog(row) {
      Object.assign(this.assign_games_config, { raw_data: row });
      this.assign_games_config.is_show = true;
    },
    /** 确认分配游戏权限 */
    confirmAssignGame() {
      this.$refs.table.refer();
      this.assign_games_config.is_show = false;
    },
  },
};
</script>
